import apiClient, { getApiErrorMessage } from './apiClient';
import { normalizeProject } from './projects.api';

const unwrapApiData = (data) => data?.data || data?.Data || data;

const normalizeFeatureCatalogItem = (feature) => ({
  id: feature?.Id || feature?.id || '',
  key: feature?.Key || feature?.key || '',
  title: feature?.Title || feature?.title || feature?.Key || feature?.key || '',
  description: feature?.Description || feature?.description || null,
  minuteCost: Number(feature?.MinuteCost ?? feature?.minuteCost ?? 0) || 0,
  metadata: feature?.Metadata || feature?.metadata || {}
});

const normalizeFeatureCatalog = (payload) => {
  const data = unwrapApiData(payload);

  if (Array.isArray(data)) {
    return data.map(normalizeFeatureCatalogItem).filter((item) => item.key);
  }

  if (Array.isArray(data?.items)) {
    return data.items.map(normalizeFeatureCatalogItem).filter((item) => item.key);
  }

  if (Array.isArray(data?.Items)) {
    return data.Items.map(normalizeFeatureCatalogItem).filter((item) => item.key);
  }

  return [];
};

export const fetchFeaturesApi = async () => {
  try {
    const { data } = await apiClient.get('/features');
    return normalizeFeatureCatalog(data);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load features.'));
  }
};

export const updateProjectFeaturesApi = async ({ projectId, features }) => {
  try {
    const { data } = await apiClient.put(`/projects/${encodeURIComponent(projectId)}/features`, {
      features
    });

    return normalizeProject(unwrapApiData(data));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update project features.'));
  }
};
